import { Formik, Form as FormikForm } from "formik";
import CustomInput from "../../../common/CustomInput";
import AcademicYearSync from "../helper/AcademicYearSync";
import { useGetSchoolSessions } from "../../../../hooks/school/session/useGetSchoolSessions";
import { useEffect } from "react";
import toast from "react-hot-toast";
import Skeleton from "react-loading-skeleton";

export const SessionFormRow = ({ onSubmit }) => {
  const today = new Date().toISOString().split("T")[0];
  const { getSchoolSessions, sessions, loading, error } =
    useGetSchoolSessions();
  const toDateInput = (date) => (date ? date.split("T")[0] : "");

  const activeSession = sessions?.find((s) => s.status === "active") || null;

  useEffect(() => {
    getSchoolSessions({
      onError: (msg) => toast.error(msg),
    });
  }, []);

  const initialValues = {
    status: "active",
    starts_at: toDateInput(activeSession?.starts_at) || today,
    ends_at: toDateInput(activeSession?.ends_at) || "",
    academic_year: activeSession?.academic_year || "",
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) =>
        loading ? (
          <Skeleton count={4} height={40} className="mb-3" />
        ) : (
          <FormikForm className="mt-4">
            {/* 🔥 AUTO academic year sync */}
            <AcademicYearSync />

            {/* Start */}
            <div className="mb-3 row">
              <label className="col-form-label col-12 col-md-3 d-none d-md-block">
                Session Start
              </label>
              <div className="col-12 col-md-9">
                <CustomInput
                  name="starts_at"
                  label="Start Date"
                  type="date"
                  layout="stacked"
                  labelClassName="d-md-none"
                />
              </div>
            </div>

            {/* End */}
            <div className="mb-3 row">
              <label className="col-form-label col-12 col-md-3 d-none d-md-block">
                Session End
              </label>
              <div className="col-12 col-md-9">
                <CustomInput
                  name="ends_at"
                  label="End Date"
                  type="date"
                  layout="stacked"
                  labelClassName="d-md-none"
                />
              </div>
            </div>

            {/* Academic Year */}
            <div className="mb-3 row">
              <label className="col-form-label col-12 col-md-3 d-none d-md-block">
                Academic Year
              </label>
              <div className="col-12 col-md-9">
                <CustomInput
                  name="academic_year"
                  label="Academic Year"
                  disabled
                  placeholder="Auto generated"
                  layout="stacked"
                  labelClassName="d-md-none"
                />
              </div>
            </div>

            <button
              type="submit"
              className="custom-modal-primary-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save Session"}
            </button>
          </FormikForm>
        )
      }
    </Formik>
  );
};
